// extracted by mini-css-extract-plugin
export var orderSummary = "_p8-0";
export var showMoreLessButton = "_p8-1";